/**
 * @file test-case.tsx
 * @description Компонент страницы каталога тест-кейсов для управления сущностями тест-кейсов в системе 
 * управления задачами. Предоставляет комплексную функциональность управления тест-кейсами, включая создание, 
 * редактирование и просмотр с поддержкой иерархических групп. Включает отслеживание статуса с 
 * визуализацией через бэйджи, связь с функциональными требованиями и категоризацию по сервисам. 
 * Включает двухвкладочный интерфейс с основным обзором и отслеживанием истории версий. 
 * Поддерживает фильтрацию по дате для организации тест-кейсов.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies ['@forms/test-case', '@utils/table-view', '@features/filter/types', '@forms/test-case/tabs']
 * @related-files ['@forms/test-case/index.tsx', '@forms/test-case/tabs/Main.tsx', '@forms/test-case/tabs/Versions.tsx']
 */

import { TestCaseForm } from '@forms/test-case';
import { getBadgeCell, getDefaultCell } from '@utils/table-view';
import { tabObject, TBaseObjectDto } from '@src/types';
import { filterComponent } from '@features/filter/types';
import { Main, Versions } from '@forms/test-case/tabs';

export const title = 'Тест кейсы';
export const searchModalTitle = 'Выбор тест кейса';
export const type = 'TestCase';
export const parentType = 'TestCaseGroup';
export const path = 'test-case';
export const form = TestCaseForm;
export const isCanAddGroups = true;
export const tabs: tabObject[] = [
    { label: 'Обзор', component: Main },
    { label: 'Версии', component: Versions, tab: 'versions' }
];

export const columns = [
    {
        id: '$item',
        header: [{ text: 'Код' }],
        width: 140,
        render: (cellValue: any) => getDefaultCell(cellValue)
    },
    {
        id: 'state',
        header: [{ text: 'Статус' }],
        width: 145,
        render: (cellValue: any) => getBadgeCell(cellValue)
    },
    {
        id: 'name',
        header: [{ text: 'наименование' }]
    },
    {
        id: 'functionalRequirement',
        header: [{ text: 'функция' }],
        width: 140,
        render: (cellValue: any) => getDefaultCell(cellValue)
    },
    {
        id: 'group',
        header: [{ text: 'группа' }],
        width: 140,
        render: (cellValue: any) => getDefaultCell(cellValue)
    },
    {
        id: 'service',
        header: [{ text: 'сервис' }],
        width: 230,
        render: (cellValue: any) => getDefaultCell(cellValue)
    }
];

export const getFilterControls = (data: TBaseObjectDto = {}): filterComponent[] => [
    {
        filterType: 'dateRange',
        filterProps: {
            label: 'Дата'
        },
        value: data.date,
        name: 'date',
        tab: 'filters'
    }
];
